(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-mcm-store-header]');
    if (!header) return;
    var toggle   = header.querySelector('[data-mcm-store-toggle]');
    var sheet    = header.querySelector('[data-mcm-store-sheet]');
    var backdrop = header.querySelector('[data-mcm-store-backdrop]');
    var close    = header.querySelector('[data-mcm-store-close]');
    if (!toggle || !sheet) return;

    function open() {
      sheet.classList.add('store-mobile--open');
      sheet.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      if (backdrop) backdrop.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function shut() {
      sheet.classList.remove('store-mobile--open');
      sheet.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      if (backdrop) backdrop.hidden = true;
      document.documentElement.style.overflow = '';
    }
    toggle.addEventListener('click', function () {
      if (sheet.classList.contains('store-mobile--open')) { shut(); } else { open(); }
    });
    if (close) close.addEventListener('click', shut);
    if (backdrop) backdrop.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('store-mobile--open')) shut();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcm-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nodes = document.querySelectorAll('[data-mcm-countdown]');
    if (!nodes.length) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick(node, deadline) {
      var diff = deadline - Date.now();
      if (diff < 0) diff = 0;
      var total = Math.floor(diff / 1000);
      var days  = Math.floor(total / 86400);
      var hrs   = Math.floor((total % 86400) / 3600);
      var mins  = Math.floor((total % 3600) / 60);
      var secs  = total % 60;
      var d = node.querySelector('[data-mcm-countdown-days]');
      var h = node.querySelector('[data-mcm-countdown-hours]');
      var m = node.querySelector('[data-mcm-countdown-mins]');
      var s = node.querySelector('[data-mcm-countdown-secs]');
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hrs);
      if (m) m.textContent = pad(mins);
      if (s) s.textContent = pad(secs);
    }

    nodes.forEach(function (node) {
      var raw = node.getAttribute('data-deadline');
      if (!raw) return;
      var deadline = Date.parse(raw);
      if (isNaN(deadline)) return;
      tick(node, deadline);
      setInterval(function () { tick(node, deadline); }, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
